
<div [ngClass]="'theme-'+ config?.theme">
  <div *ngIf="config?.showHeading" class="heading">
    <div class="title">Eminent Donors on Ketto</div>
  </div>

  <div class="twiiter-slider">
    <ngx-glide [showArrows]="config?.showArrows" [showBullets]="false" [autoplay]="config?.autoplay" [perView]="config?.theme?.match('v1')? 3.05:3" [gap]="20" [bound]="true" [breakpoints]="breakpoints" arrowLeftLabel="" arrowRightLabel="">
      <div *ngFor="let tweet of tweets" class="twitter-slide static">
        <img *ngIf="config?.param?.santa" src="../assets/images/santa-cap.png" class="santa-cap" alt="">
        <a href="{{tweet?.redirect_to}}" target="_blank" (click)="goToTweetEvent()" class="imgs">
          <img loading="lazy" [attr.data-src]="tweet?.image" [default]="util.defaultImg" alt="tweet"  class="tweet"/>
        </a>
      </div>
    </ngx-glide>
  </div>
</div>

